import { useEffect, useState } from 'react';
import Popup from '../../Popup/Popup';
import $ from 'jquery';
import CommonAPICalls from '../Common Integration Calls/CommonApiCalls';
import SimpleLoading from '../../Loading/SimpleLoading'; 
import { formatJson, getPopupMessageBasedOnStatus } from '../../../inc/Validation';
import Helper from '../../../inc/Helper';

/*

The save/PUT functionality is commented upon Waqas's request, if in future its needed then uncomment the buttons code & remove textarea from disabled
refreshParentGrid -> refresh parent grid

*/

const PayloadDetails = ({ setClosePopupViewModal, refreshParentGrid, apiDetailsPayload={} }) => {
    const [apiPayloadRes, setApiPayloadRes] = useState({});
    const [editablePayload, setEditablePayload] = useState('');
    const [loadingApi, setLoadingApi] = useState(!apiDetailsPayload?.apiResponsePreview);

    const apiCalls = new CommonAPICalls();  

    useEffect(() => { 
        if (apiDetailsPayload?.queue_id && !apiDetailsPayload?.apiResponsePreview) {
            fetchDataForApiPayload();
        }  
    }, [apiDetailsPayload?.queue_id]);

    const fetchDataForApiPayload = async () => {
        try {
            const payloadDetailsApiResponse = await apiCalls.getSystemPayloadApiDetails(apiDetailsPayload?.queue_id, apiDetailsPayload?.tenant);
            if (payloadDetailsApiResponse) {
                setApiPayloadRes(payloadDetailsApiResponse?.data); 
                setEditablePayload(formatJson(payloadDetailsApiResponse?.data?.converted_data) || '');
                setLoadingApi(false);
            } else {
                setApiPayloadRes({}); 
                setEditablePayload('');
                setLoadingApi(false);
            };
        } catch (error) {
            setApiPayloadRes({});
            setEditablePayload('');
            setLoadingApi(false);
        };
    };

    const onClosePopupClick = () => {
        $("html").removeClass("rs_popup_open");
        setClosePopupViewModal(false);
    };

    const ApiDetailsFormated = () => {
        const paragraphStyle = {
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };

        const paragraphFonts = { fontWeight: '800' };
        return (  
            <>
                {apiDetailsPayload?.apiResponsePreview ? (
                    <p style={paragraphStyle}>
                        <span style={paragraphFonts}>Api response:</span> {apiDetailsPayload?.api_response}
                    </p>
                ) : (
                    <>
                        <p style={paragraphStyle}>
                            <span style={paragraphFonts}>Api url:</span> {apiPayloadRes?.api_url}
                        </p>
                        <p style={paragraphStyle}>
                            <span style={paragraphFonts}>Api method:</span> {apiPayloadRes?.api_method}
                        </p>
                        <p style={paragraphStyle}>
                            <span style={paragraphFonts}>Api response:</span> {apiPayloadRes?.api_response}
                        </p>
                        <p style={{...paragraphStyle, margin: 0}}>
                            <span style={paragraphFonts}>Converted data:</span> 
                        </p> 
                    </>
                )}
            </>
        );
    };

    const onSaveHandler = async () => {
        try {
            setLoadingApi(true);
            const dataQueueResponse = await apiCalls.updateSystemDataQueue(apiPayloadRes?.queue_id, apiDetailsPayload?.tenant, { converted_data: editablePayload });
            if (dataQueueResponse?.status) { 
                Helper.alert(dataQueueResponse?.data?.message || 'Updated data queue successfully');
                setLoadingApi(false);
            } else {
                Helper.alert(dataQueueResponse?.data?.message || 'Apologies, something went wrong', 'error');
                setLoadingApi(false);
            }
        } catch (error) {
            getPopupMessageBasedOnStatus(error);
            setLoadingApi(false);
        }
    };

    return (
        <Popup
            autoOpen={true}
            width="900px"
            onClose={onClosePopupClick}
        >
            {
                loadingApi ? <SimpleLoading /> 
                : (
                    <>
                        <ApiDetailsFormated />
                        
                        {
                            !apiDetailsPayload?.apiResponsePreview && 
                            <textarea
                                className="payload_json_formatter_class"
                                value={editablePayload}
                                disabled={true}
                                onChange={(e) => setEditablePayload(e.target.value)}
                            />
                        }
                    </>
                )
            }

            {/* <div className="addDocumentNumber-body-buttons" style={{ justifyContent: "flex-end", marginTop: '15px' }}>
                <Button
                    isActive={false} 
                    isDisable={loadingApi}
                    className='black-btn-style'
                    title={ "Close" }
                    onClick={onClosePopupClick}
                />
                <Button
                    isDisable={loadingApi}
                    className="rfq_save_btn" isActive={true}
                    title={ "Save" }
                    onClick={onSaveHandler}
                />
            </div> */}
        </Popup>
    );
};

export default PayloadDetails;